
import { gql } from "@apollo/client";

export const FORGET_PASSWORD_MUTATION = gql`
mutation ForgetPassword($data: ForgetPasswordInput!) {
  forgetPassword(data: $data) {
	success
	message
  }
}
`;

export const VERIFY_TOKEN_MUTATION = gql`
  mutation VerifyToken($data: VerifyTokenInput!) {
    verifyToken(data: $data) {
      message
      expires_in
      access_token
      email
    }
  }
`;

export const SET_NEW_PASSWORD_MUTATION = gql`
  mutation SetNewPassword($data: SetNewPasswordInput!) {
    setNewPassword(data: $data) {
      message
    }
  }
`;

